module.exports = __webpack_public_path__ + "img/software_test.1cb6349c.png";